// TODO: This can be added to the Validator.Array function in future. #286159
export const getUniquenessValidator = (key) => {
    return (values, logger, logLabel) => {
        const valueSet = new Set();
        return values.every(value => {
            const keyedValue = key ? value[key] : value;
            if (valueSet.has(keyedValue)) {
                const logMessage = key
                    ? `${logLabel} invalid. Cannot provide duplicate value '${keyedValue}' for '${String(key)}'.`
                    : `${logLabel} invalid. Cannot provide duplicate value '${keyedValue}'.`;
                logger(logMessage);
                return false;
            }
            valueSet.add(keyedValue);
            return true;
        });
    };
};
//# sourceMappingURL=uniqueness-validator.js.map